"use strict";

import gsap from "gsap";
import { CustomEase } from "gsap/all";

const projOutAnimation = function (container) {
	gsap.registerPlugin(CustomEase);

	const image = container.querySelector(".display-image"),
		logo = container.querySelector(".client-logo"),
		textContent = container.querySelectorAll(".project-content > *");

	const breakPoint = gsap.matchMedia();
	const tl = gsap.timeline({
		defaults: {
			duration: 1,
			ease: CustomEase.create("custom", "M0,0 C0.105,1 0.617,0.985 1,1 "),
			onComplete: () => {
				return false;
			},
		},
	});

	breakPoint.add("(max-width: 1024px)", () => {
		tl.to(textContent[3], { y: "150%" }, 0)
			.to(textContent[3], { opacity: 0, duration: 0.1, ease: "none" }, "<")
			.to(textContent[2], { y: "80%" }, "<0.1")
			.to(textContent[2], { opacity: 0, duration: 0.1, ease: "none" }, "<")
			.to(textContent[1], { y: "100%" }, "<0.1")
			.to(textContent[1], { opacity: 0, duration: 0.1, ease: "none" }, "<")
			.to(textContent[0], { y: "400%" }, "<0.1")
			.to(textContent[0], { opacity: 0, duration: 0.1, ease: "none" }, "<")
			.to(image, { y: "50%", duration: 1.5 }, "<-=0.2")
			.to(image, { opacity: 0, duration: 0.2, ease: "none" }, "<")

			.to(logo, { opacity: 0, duration: 0.8, ease: "none" }, 0)
			.to(logo, { y: "100%", duration: 0.01 }, ">-=0.2")
			.to(container, { autoAlpha: 0, duration: 0.01 });
	});

	breakPoint.add("(min-width: 1025px)", () => {
		tl.to(image, { y: "50%", duration: 1.5 }, 0.1)
			.to(image, { opacity: 0, duration: 0.2, ease: "none" }, "<")
			.to(textContent[3], { y: "150%" }, 0)
			.to(textContent[3], { opacity: 0, duration: 0.1, ease: "none" }, "<")
			.to(textContent[2], { y: "80%" }, "<0.1")
			.to(textContent[2], { opacity: 0, duration: 0.1, ease: "none" }, "<")
			.to(textContent[1], { y: "100%" }, "<0.1")
			.to(textContent[1], { opacity: 0, duration: 0.1, ease: "none" }, "<")
			.to(textContent[0], { y: "400%" }, "<0.1")
			.to(textContent[0], { opacity: 0, duration: 0.1, ease: "none" }, "<")
			.to(logo, { opacity: 0, duration: 0.8, ease: "none" }, 0)
			.to(logo, { y: "100%", duration: 0.01 }, ">-=0.2")
			.to(container, { autoAlpha: 0, duration: 0.01 });
	});

	return tl;
};

export default projOutAnimation;
